import React from 'react';
import './Background.scss';

function Background() {
  return (
    <div className="background-wrapper absolute">
      <i className="icon icon-hexagon" />
      <i className="icon icon-hexagon" />
      <i className="icon icon-hexagon" />
      <i className="icon icon-hexagon" />
      <i className="icon icon-hexagon" />
    </div>
  );
}

export default Background;
